var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 960,
    height: 640,
    viewBox: "0 0 960 640",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3157_24090)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 815,
    cy: 13,
    r: 89,
    fill: "#94DBF2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 913,
    cy: 632,
    r: 113,
    fill: "#94DBF2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 557,
    cy: 691,
    r: 144,
    fill: "#94DBF2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 34,
    r: 113,
    fill: "#94DBF2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -5,
    cy: 586,
    r: 67,
    fill: "#94DBF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.326 556.042L209.665 562.296L149.213 787.908C148.062 792.205 143.645 794.755 139.349 793.603L123.789 789.434L186.326 556.042Z",
    fill: "#307ACF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.877,
    y: 550.831,
    width: 20.1354,
    height: 241.625,
    transform: "rotate(15 166.877 550.831)",
    fill: "#206087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.537 544.577L166.876 550.831L104.339 784.223L88.7795 780.054C84.4829 778.902 81.9331 774.486 83.0844 770.189L143.537 544.577Z",
    fill: "#2A4C76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.538 544.577L172.282 503.431L194.794 471.831C196.906 468.867 201.302 470.045 201.649 473.668L205.345 512.29L209.665 562.296L183.199 567.712L163.75 562.5L143.538 544.577Z",
    fill: "#94DBF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.266 501.011L201.294 469.941C201.082 467.739 198.25 466.98 196.966 468.781L178.856 494.202L179.355 494.622C186.079 500.282 194.967 502.664 203.621 501.124L204.266 501.011Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.806 103.068L947.72 97.1379L890.4 -95.3617C889.308 -99.0277 885.451 -101.115 881.785 -100.023L868.509 -96.0699L927.806 103.068Z",
    fill: "#307ACF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.3149,
    height: 207.778,
    transform: "matrix(0.958413 -0.285384 -0.285384 -0.958413 911.211 108.009)",
    fill: "#206087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.297 113.938L911.211 108.009L851.914 -91.1287L838.638 -87.1756C834.972 -86.0839 832.885 -82.2271 833.977 -78.5611L891.297 113.938Z",
    fill: "#2A4C76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.297 113.939L916.983 148.625L937.084 175.254C938.969 177.751 942.72 176.634 942.933 173.512L945.192 140.225L947.72 97.1381L924.841 93.1109L908.246 98.0523L891.297 113.939Z",
    fill: "#94DBF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.534 149.946L942.716 176.725C942.586 178.623 940.17 179.342 939.023 177.824L922.853 156.402L923.272 156.03C928.918 151.004 936.501 148.746 943.977 149.865L944.534 149.946Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.957 399.751L913.403 380.304L1101.39 568.288C1104.97 571.868 1104.97 577.673 1101.39 581.253L1088.42 594.217L893.957 399.751Z",
    fill: "#307ACF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 877.751,
    y: 415.957,
    width: 22.9181,
    height: 275.017,
    transform: "rotate(-45 877.751 415.957)",
    fill: "#206087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.305 435.404L877.751 415.957L1072.22 610.423L1059.25 623.388C1055.67 626.968 1049.87 626.968 1046.29 623.388L858.305 435.404Z",
    fill: "#2A4C76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.304 435.403L834.105 383.653L815.768 343.48C814.049 339.711 817.712 336.048 821.48 337.768L861.653 356.105L913.403 380.304L903.68 409.474L887.474 425.68L858.304 435.403Z",
    fill: "#94DBF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.922 350.748L817.604 335.997C815.313 334.952 812.953 337.312 813.998 339.603L828.75 371.921L829.447 371.668C838.853 368.261 846.259 360.855 849.666 351.449L849.922 350.748Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1421 280.082L55.7494 266.107L-79.3413 395.57C-81.914 398.035 -82.0009 402.119 -79.5353 404.692L-70.6069 414.009L69.1421 280.082Z",
    fill: "#307ACF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.1302,
    height: 193.562,
    transform: "matrix(-0.691909 -0.721985 -0.721985 0.691909 80.303 291.727)",
    fill: "#206087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6954 305.703L80.3027 291.728L-59.4462 425.655L-50.5178 434.972C-48.0522 437.544 -43.9679 437.631 -41.3952 435.166L93.6954 305.703Z",
    fill: "#2A4C76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6957 305.702L111.498 269.65L125.003 241.656C126.269 239.03 123.746 236.398 121.069 237.551L92.526 249.853L55.7496 266.107L62.1549 286.778L73.3155 298.424L93.6957 305.702Z",
    fill: "#94DBF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.861 246.26L123.823 236.363C125.451 235.662 127.076 237.358 126.306 238.955L115.442 261.475L114.956 261.286C108.388 258.748 103.287 253.426 101.031 246.756L100.861 246.26Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.72 595.93L354.914 586.377L447.262 800.917C449.021 805.002 447.134 809.74 443.049 811.499L428.253 817.868L332.72 595.93Z",
    fill: "#307ACF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.225,
    y: 603.892,
    width: 20.1354,
    height: 241.625,
    transform: "rotate(-23.2894 314.225 603.892)",
    fill: "#206087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.031 613.445L314.225 603.892L409.758 825.829L394.962 832.198C390.876 833.957 386.138 832.071 384.38 827.985L292.031 613.445Z",
    fill: "#2A4C76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.031 613.445L289.097 563.339L287.186 524.587C287.007 520.952 291.188 519.153 293.705 521.781L320.537 549.806L354.913 586.377L337.496 607.027L319.002 614.988L292.031 613.445Z",
    fill: "#94DBF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.702 541.62L291.117 519.076C289.586 517.478 286.893 518.637 287.001 520.847L288.539 552.021L289.19 552.041C297.976 552.318 306.428 548.679 312.266 542.109L312.702 541.62Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3157_24090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 640,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheme);
export default __webpack_public_path__ + "static/media/theme.97848e7ea90a586894b033c1a5b42fab.svg";
export { ForwardRef as ReactComponent };